import { render } from "./StandOrt.vue?vue&type=template&id=5dae0d76&scoped=true"
import script from "./StandOrt.vue?vue&type=script&lang=js"
export * from "./StandOrt.vue?vue&type=script&lang=js"

import "./StandOrt.vue?vue&type=style&index=0&id=5dae0d76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dae0d76"]])

export default __exports__